import { Attachment } from "../components/attachment/Attachment";
import { DomEvent } from "./DomEvent";
import { Event, EventListener } from "./Event";

export interface FileUploadListener extends EventListener<FileUploadEvent> {
}

export class FileUploadEvent extends Event<Attachment> {
    private file: File = null;

    constructor(component: Attachment, file: File, domEvent?: DomEvent) {
        super(component, domEvent);
        this.file = file;
    }

    public getFile(): File {
        return this.file;
    }
}
